import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';
import { Select2Init } from '../utils/Select2Init';

export default class NewsletterContentComponent extends Component {
    get SELECTORS() {
        return {
            input: '.n-p__content__input',
            emailInput: 'input[name="email"]',
            moreContainer: '[data-more-container]',
            submitButton: 'button[type="submit"]',
            privacyCheckbox: '.n-p__content__form__checkbox',
            newsletterBox: '.w-newsletter-module.module-newsletter',
            formBox: '.w-newsletter-module.module-newsletter [data-form-box]',
            form: '.n-p__content__form',
            formWrapper: '.n-p__form-email',
            errorSubscribed: '.error-already-subscribed',
            errorEmail: '.error-email-invalid',
            errorGeneric: '.error-generic',
            newsletterWrapper: ".n-p__content--registration",
            newslettersuccess: ".n-p__success"
        };
    }

    get CLASSES() {
        return {
            success: 'success',
            componentExtended: 'extended',
        };
    }

    constructor(compEl) {
        super(compEl);
        this.input = this.$component.querySelector(this.SELECTORS.input);
        this.moreContainer = this.$component.querySelector(this.SELECTORS.moreContainer);
        this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
        this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
        this.formBox = this.$component.querySelector(this.SELECTORS.formBox);
        this.errorSubscribed = this.$component.querySelector(this.SELECTORS.errorSubscribed);
        this.errorEmail = this.$component.querySelector(this.SELECTORS.errorEmail);
        this.errorGeneric = this.$component.querySelector(this.SELECTORS.errorGeneric);
        this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
        this.form = this.$component.querySelector(this.SELECTORS.form);
        this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
        this.newsletterWrapper = this.$component.querySelector(this.SELECTORS.newsletterWrapper);
        this.newslettersuccess = this.$component.querySelector(this.SELECTORS.newslettersuccess);

        Select2Init();
        $('select#newsletterForm\\.nation').select2({
            resolve: 'width',
            minimumResultsForSearch: 1,
            containerCssClass: 'custom-dt-container',
            dropdownCssClass: 'custom-dt-dropdown'
        })

    }

    // enable form submit button
    enableSubmitBtn() {
        if (this.privacyCheckbox.checked === true && this.submitButton != null ) {
            this.submitButton.disabled = false;
        } else {
            this.submitButton.disabled = true;
        }
    }

    checkSubmit() {
        // enable submit
        if (this.privacyCheckbox != null) {
            this.privacyCheckbox.addEventListener('click', e => {
                this.enableSubmitBtn();
            });
        }
    }

    bindEvents() {
        let ctx = this;

        this.checkSubmit();

        this.input.addEventListener('focus', () => {
            this.formBox.classList.add(this.CLASSES.componentExtended);
            // this.checkSubmit();
        });
        //
        this.$on('submit.nl-module-submission', this.NewsletterLogic.subscribeToNewsletter, ctx.SELECTORS.newsletterBox, ctx.SELECTORS.form, ctx);
        // after subscription event
        this.$on(this.$customEvents.NL_MODULE_EVENTS.subscribed, ({ event, payload }) => {
            // go logic
            this.NewsletterLogic.afterSubscription(ctx);
        });
    }

    render() {
        let ctx = this;
        // loading logics
        this.NewsletterLogic = new NewsletterLogic();
        this.bindEvents();
    }
}
